"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montenars": {
    "acb92195": [{
      "hkey": "f0da4e3f",
      "slug": "san-giorgio",
      "name": "San Giorgio",
      "primary": true,
      "skipSearch": false
    }],
    "cologna": [{
      "hkey": "f0da4e3f",
      "slug": "san-giorgio",
      "name": "San Giorgio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ff2c7922": [{
      "hkey": "1d8cc9f7",
      "slug": "sant-elena",
      "name": "Sant'Elena",
      "primary": true,
      "skipSearch": false
    }],
    "isola": [{
      "hkey": "1d8cc9f7",
      "slug": "sant-elena",
      "name": "Sant'Elena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;